import { render } from "./Section-5.vue?vue&type=template&id=53db1adf&scoped=true"
import script from "./Section-5.vue?vue&type=script&lang=js"
export * from "./Section-5.vue?vue&type=script&lang=js"

import "./Section-5.vue?vue&type=style&index=0&id=53db1adf&scoped=true&style=scss&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53db1adf"]])

export default __exports__